import wcharts from "@/data/widgets/charts/wcharts";

export const top=[
    {
        id:1,
        title: 'SALE',
        count: 90,
        counter:3654,
        symbol: '$',
        class: 'font-primary',
        chart : wcharts.one
    },
    {
        id:2,
        title: 'PROJECTS',
        count: 30,
        counter:12569,
        symbol: '',
        class: 'font-secondary',
        chart : wcharts.two
    },
    {
        id:3,
        title: 'PRODUCTS',
        count: 68,
        counter:93,
        point: 'M',
        symbol: '',
        class: 'txt-success',
        chart : wcharts.three
    },
]
